import clsx from "clsx";
import { Fragment, JSX } from "react";

import { formatPrettyDecimal, isNumeric } from "@tsmono/util";

import { ScoreValue } from "../../../../@types/extraInspect";
import { kScoreTypeObject } from "../../../../constants";
import { ScoreDescriptor } from "../types";

import styles from "./ObjectScoreDescriptor.module.css";

export const objectScoreDescriptor = (
  values: ScoreValue[]
): ScoreDescriptor => {
  const buckets = values.map((val) => {
    return JSON.stringify(val);
  });
  const vals = new Set(buckets);
  let categories = undefined;
  if (vals.size < 10) {
    categories = Array.from(vals).map((val) => {
      return {
        val,
        text: val,
      };
    });
  }

  return {
    scoreType: kScoreTypeObject,
    categories,
    filterable: false,
    compare: () => {
      return 0;
    },
    render: (score) => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (score === null || score === undefined) {
        return "[null]";
      }

      const scores: JSX.Element[] = [];
      const keys = Object.keys(score);
      keys.forEach((key) => {
        if (typeof score !== "object" || Array.isArray(score)) {
          throw new Error(
            "Unexpected use of object score descriptor for non-score object"
          );
        }
        const value = score[key];
        const formattedValue =
          value && isNumeric(value)
            ? formatPrettyDecimal(
                typeof value === "number"
                  ? value
                  : parseFloat(value === true ? "1" : value)
              )
            : String(value);

        scores.push(
          <Fragment key={key}>
            <div className={clsx(styles.key, "text-size-smaller")} title={key}>
              {key}
            </div>
            <div className={clsx(styles.value, "text-size-base")}>
              {formattedValue}
            </div>
          </Fragment>
        );
      });

      return (
        <div key={`score-value`} className={clsx(styles.container)}>
          {scores}
        </div>
      );
    },
  };
};
